import config from "@/lib/config";
import { useDeviceInfoQuery } from "@/hooks";
import styles from "@/styles/Video.module.scss";

export default function AndroidAppDownloadBanner() {
  const { data: { deviceInfo } = {} } = useDeviceInfoQuery({
    fetchPolicy: "cache-first",
  });
  const { isAndroid } = deviceInfo ?? {};
  if (!isAndroid) return null;
  const href = config.appStoreUrl.android;
  return (
    <a className={styles["getin-googleplay"]} href={href}>
      <img
        alt="Google Play で手に入れよう"
        src="/images/google_play_badge.png"
      />
    </a>
  );
}
